import apiClient from './api'

export interface BulkOperationRequest {
  ids: string[]
  operation: 'approve' | 'reject' | 'update-status' | 'assign'
  data?: {
    reason?: string
    assignTo?: string
    status?: string
  }
}

export interface BulkOperationResponse {
  success: number
  failed: number
  errors?: Array<{ id: string; error: string }>
}

export const bulkService = {
  // Bulk approve transactions
  bulkApprove: async (ids: string[]): Promise<BulkOperationResponse> => {
    try {
      const response = await apiClient.post('/transactions/bulk/approve', { ids })
      return response.data
    } catch (error: any) {
      console.error('Bulk approve failed', error)
      throw new Error(error.response?.data?.message || 'Failed to approve transactions')
    }
  },

  // Bulk reject transactions
  bulkReject: async (ids: string[], reason: string): Promise<BulkOperationResponse> => {
    try {
      const response = await apiClient.post('/transactions/bulk/reject', { ids, reason })
      return response.data
    } catch (error: any) {
      console.error('Bulk reject failed', error)
      throw new Error(error.response?.data?.message || 'Failed to reject transactions')
    }
  },

  // Bulk update status
  bulkUpdateStatus: async (ids: string[], status: string): Promise<BulkOperationResponse> => {
    try {
      const response = await apiClient.post('/transactions/bulk/update-status', { ids, status })
      return response.data
    } catch (error: any) {
      console.error('Bulk update status failed', error)
      throw new Error(error.response?.data?.message || 'Failed to update transaction status')
    }
  },

  // Bulk assign
  bulkAssign: async (ids: string[], assignTo: string): Promise<BulkOperationResponse> => {
    try {
      const response = await apiClient.post('/transactions/bulk/assign', { ids, assignTo })
      return response.data
    } catch (error: any) {
      console.error('Bulk assign failed', error)
      throw new Error(error.response?.data?.message || 'Failed to assign transactions')
    }
  },

  // Generic bulk operation
  executeBulkOperation: async (request: BulkOperationRequest): Promise<BulkOperationResponse> => {
    switch (request.operation) {
      case 'approve':
        return bulkService.bulkApprove(request.ids)
      case 'reject':
        return bulkService.bulkReject(request.ids, request.data?.reason || '')
      case 'update-status':
        return bulkService.bulkUpdateStatus(request.ids, request.data?.status || '')
      case 'assign':
        return bulkService.bulkAssign(request.ids, request.data?.assignTo || '')
      default:
        throw new Error('Unknown bulk operation')
    }
  },
}


